import React from "react";
import { saveFunding } from "../../services";
import { faToggleOn } from "@fortawesome/pro-solid-svg-icons";
import { faToggleOff } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EnableFundingToggleSwitch = (props) => {
  const {
    planId,
    modeOfFunding,
    toggle,
    setToggle,
    id,
    achToggle,
    planCashToggle,
    forfeitureToggle,
  } = props;

  return (
    <div
      className="toggleBox"
      style={{
        background: toggle
          ? "linear-gradient(0deg, rgba(6, 116, 26, 0.1), rgba(6, 116, 26, 0.1)), #FFFFFF"
          : "linear-gradient(0deg, rgba(196, 6, 26, 0.1), rgba(196, 6, 26, 0.1)), #FFFFFF",
      }}
    >
      <FontAwesomeIcon
        className={`toggleIcon ${toggle ? "primary-small" : "grey-shade"}`}
        onClick={() => {
          setToggle(!toggle);
          saveFunding({
            id: id ?? 0,
            planCashAccountEnabled: planCashToggle,
            forfeitureAccountEnabled: forfeitureToggle,
            achAccountEnabled: achToggle,
            planId: planId,
            [modeOfFunding]: !toggle,
          });
        }}
        icon={toggle ? faToggleOn : faToggleOff}
        size="2x"
      />
      <span
        className="toggletext"
        style={{
          color: toggle ? "#06741A" : "#C4061A",
        }}
      >
        {toggle ? "Enabled for funding" : "Enable for funding"}
      </span>
    </div>
  );
};

export default EnableFundingToggleSwitch;
